<template>
  <div class="divider"></div>
</template>

<style lang="scss">
@import "./style.scss";
</style>
